"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
var deepmerge_1 = __importDefault(require("deepmerge"));
var react_1 = __importDefault(require("react"));
var core_1 = require("../../shared/core");
var keys = {
    heading: 'helloWorld.heading',
    body: 'helloWorld.body',
    ctaText: 'helloWorld.ctaText',
    featureHeading: 'helloWorld.featureHeading',
    featureBody: 'helloWorld.featureBody',
};
var ProfileLink = function (_a) {
    var children = _a.children;
    var TextLink = (0, core_1.useComponents)().TextLink;
    var profile = (0, core_1.useLinks)().profile;
    return react_1.default.createElement(TextLink, { href: profile() }, children);
};
var CurrencyExample = function () {
    return react_1.default.createElement(react_1.default.Fragment, null, (0, core_1.major2DP)(250));
};
var defaultTranslations = (0, deepmerge_1.default)(core_1.translations, {
    en: {
        helloWorld: {
            heading: 'Hello World!',
            body: '<P>View <ProfileLink>your profile</ProfileLink>. You have <CurrencyExample />.</P>',
            ctaText: 'Click me',
            featureHeading: 'Example feature',
            featureBody: '<P>Please enjoy this great feature.</P>',
        },
    },
});
var defaultOptions = {
    keys: keys,
    defaultTranslations: defaultTranslations,
    components: {
        ProfileLink: ProfileLink,
        CurrencyExample: CurrencyExample,
    },
};
exports.defaultOptions = defaultOptions;
